module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/english-090c511146244095.png"+" 48w",
        images: [{path: __webpack_public_path__ + "assets/images/english-090c511146244095.png",width: 48,height: 48}],
        src: __webpack_public_path__ + "assets/images/english-090c511146244095.png",
        toString: function(){return __webpack_public_path__ + "assets/images/english-090c511146244095.png"},
        
        width: 48,
        height: 48
      }